<div class="custom-options">
  <app-form-lablel
    [label]="label"
    class="add-margin-top container-label"
  ></app-form-lablel>
  <mat-form-field
    appearance="outline"
    class="container-form-field"
    [ngStyle]="{ 'max-width': width, 'min-width': width }"
  >
    <mat-select
      [value]="innerValue"
      [disabled]="disabled"
      [placeholder]="placeholder"
      #input
      #select
      class="select-options"
      (selectionChange)="onChange($event)"
    >
      <mat-option
        *ngFor="let option of options"
        [value]="optionValue ? option[optionValue] : option"
        class="select-options"
      >
        {{ optionDescription ? option[optionDescription] : option }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-error class="container-error" *ngIf="hasError">{{
    messageError
  }}</mat-error>
</div>
